<template>
  <ServicePageLayout
    title="Users"
    subtitle="บริหารจัดการผู้ใช้งาน"
    icon="mdi-account-multiple-check-outline"
    breadcrumb="System"
  >
    <v-card flat class="service-content-panel">
      <v-card-text><USERS_DATATABLE /></v-card-text>
    </v-card>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'
import USERS_DATATABLE from '@/components/users/users_table'

export default {
  name: 'UsersView',
  components: {
    ServicePageLayout,
    USERS_DATATABLE
  },
}
</script>
